import React from "react";

import { FlipmailMailboxLoader } from "./FlipmailMailboxLoader.jsx";

/** Centered loader for the main content area; use only when `query.isLoading` (first fetch), not background refetch. */
export function PageFirstLoadSpinner({ className = "", minHeightClass = "min-h-[40vh]", size = 80 }) {
  return (
    <div
      className={`flex w-full items-center justify-center py-16 ${minHeightClass} ${className}`.trim()}
      role="status"
      aria-label="Loading"
    >
      <FlipmailMailboxLoader size={size} decorative />
    </div>
  );
}
